import NetInfo from "@react-native-community/netinfo"
import React from "react"

import { setIsOnline } from "@/redux/network.reducer"
import { useRootDispatch } from "@/redux/useRootDispatch"

/**
 * Subscribes once to NetInfo and mirrors reachability into the Redux
 * ``network`` slice. Mount in a layout that renders for the lifetime of
 * the authenticated session (i.e. dashboard layout) so the offline
 * indicator and the toast suppression in ``useErrorHandler`` share a
 * single source of truth.
 *
 * ``isInternetReachable`` is preferred when defined — ``isConnected``
 * can report ``true`` for captive-portal Wi-Fi where DNS is still
 * blocked. When ``isInternetReachable`` is ``null`` (still probing),
 * fall back to ``isConnected`` to avoid flapping the indicator on cold
 * start.
 */
export function useNetworkStatusSync(): void {
  const dispatch = useRootDispatch()
  React.useEffect(() => {
    const unsubscribe = NetInfo.addEventListener((state) => {
      const reachable =
        state.isInternetReachable ?? state.isConnected ?? true
      dispatch(setIsOnline(reachable))
    })
    return unsubscribe
  }, [dispatch])
}
